var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
export default /*#__PURE__*/React.memo(function SvgSorting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    role: "presentation",
    "data-ignore-dark-theme-adapter": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#999",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    d: "m3 7.5 3 3 3-3M9 4.5l-3-3-3 3"
  })));
});